// extracted by mini-css-extract-plugin
export default {"container":"mIPUNHmncCf971W38Kmucg==","title":"_7C6y-MDzKsi4W49vWTV9kg==","list":"m8yBBFF3JW-JgZGtjh8WQg==","list-item":"cyWzJk3ZNgN-2cYN2QDKvA==","image":"gkgaiuZcLKyeuivvXQ0AYg=="};